export enum Category {
  "INTERIOR" = "interior-design",
  "EXTERIOR" = "architecture",
  "LANDSCAPE" = "landscape",
  "ALL" = "all",
  "3D" = "3d",
}
